import sentinelToEmpty from '../sentinelValue'

/**
 * Normaliseert het persona-segment uit de publieke vragenlijst-URL. De
 * deellink ('Vragenlijst delen') zet bij een anonieme meting letterlijk
 * 'undefined' in dat segment — die tekst mag nooit als deelnemer-ID worden
 * opgeslagen, anders delen alle anonieme respondenten van die link één
 * nep-deelnemer (inbox #93).
 *
 * '' TELT HIER ALS SENTINEL: een leeg segment is een anonieme meting, en dat
 * was het al (`!param`). De waarde gaat als `PersonaID: persona || ''` naar
 * `QuestionnairesResponses`, dus '' is precies de bestaande 'geen deelnemer'.
 *
 * DIT IS DE ENIGE PLEK WAAR DE GEDEELDE LIJST ÉCHT VERRUIMT, en dat is bewust.
 * Deze kopie toetste alleen op 'undefined' en 'null', hoofdlettergevoelig en
 * zonder trim. Nu vallen ook 'NaN', 'none' en 'NULL' weg, en wordt het segment
 * getrimd. Een persona-ID is een uuid; die kan geen van die woorden zijn, en
 * een ID met een spatie eromheen wijst sowieso geen document aan. Wat wél
 * verandert is dat zulke rommel nu '' oplevert (anoniem, telt gewoon mee) in
 * plaats van een nep-deelnemer waar alle respondenten van die link onder
 * belanden — precies de fout uit #93, maar dan met een ander woord.
 *
 * AI-CONTEXT: See docs/pitfalls.md#database-url-sentinel-string-persisted
 *
 * @param {string|undefined} param - Rauw URL-segment
 * @returns {string} Persona-ID, of '' voor een anonieme meting
 */
const normalizePersonaParam = (param) => sentinelToEmpty(param)

export default normalizePersonaParam
